import React from 'react';
import Chart from './Chart';

export default function StackedPercentageAreaChart(props) {

  const stackedPercentageAreaOptions = {
    chart: {
      type: 'area',
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: [{
      gridLineWidth: 1,
      gridLineDashStyle: 'Dash',
      title: {
        text: ''
      },
      labels: {
        format: '{value}%'
      },
      max: 100
    }],
    plotOptions: {
      areaspline: {
        lineWidth: 1,
        marker: {
          enabled: false
        },
        shadow: false,
        states: {
          hover: {
            lineWidth: 1
          }
        },
        threshold: null
      },
      area: {
        stacking: 'percent',
        lineColor: '#ffffff',
        lineWidth: 1,
        marker: {
          enabled: false
        }
      }
    }
  }

  function serieOption(data) {
    return {
      ...stackedPercentageAreaOptions,
      series: data,
    }
  }

  return (
    <Chart
      options={serieOption(props.data)}
      legendOptions={props.legendOptions}
    />
  )
}
